import { Component, Input, Signal, signal } from '@angular/core';

import { SportConstant } from '@frontend/sports/common/core/data-access/constants';
import { RouteTag } from '@frontend/sports/common/core/data-access/route';
import { StringDictionary } from '@frontend/sports/common/core/utils/extended-types';
import { DeviceSizeService } from '@frontend/sports/common/core/utils/media-query';
import { ListItemComponent } from '@frontend/sports/common/ui/sports-list-items';
import { TrackReferringACtionDirective, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';
import { Observable } from 'rxjs';

import { HeadingComponent } from '../../../common/heading.component';
import { SportTreeItem } from '../../../competition-list/competition-list.models';

@Component({
    selector: 'ms-sport-list',
    templateUrl: 'sport-list.component.html',
    styleUrl: './sport-list.component.scss',
    imports: [HeadingComponent, ListItemComponent, TrackReferringACtionDirective],
})
export class SportListComponent {
    @Input() sports: SportTreeItem[] = [];
    @Input() title: string;
    @Input() trackingPrefix?: string;
    @Input() crmPromoted: StringDictionary<number> = {};
    mediaQuery$: Observable<boolean>;
    isMobile: Signal<boolean | undefined>;
    trackingValue = signal<string>('M2_ListItemlinks');
    cleanedAfterTrack = signal(false);

    constructor(
        private trackingService: TrackingService,
        private deviceSizeService: DeviceSizeService,
    ) {
        this.isMobile = this.deviceSizeService.isMobile;
    }

    onSelected(selected: SportTreeItem) {
        this.cleanedAfterTrack.update(() => selected.href?.indexOf('http') === 0 || false);
        this.sendTracking(selected.id as number);
    }

    showBorder(isLastItem: boolean): boolean {
        return !this.isMobile() || !isLastItem;
    }

    private sendTracking(sport: number): void {
        const sportId = sport === SportConstant.EsportsGroup ? RouteTag.EsportsLobby : sport;
        if (this.trackingPrefix) {
            const trackingData = {
                [trackingConstants.PAGE_NAVIGATION_MENUS]: `${this.trackingPrefix}_${sportId}`,
            };

            this.trackingService.track(trackingConstants.EVENT_AZSPORTS, trackingData);
        }
    }
}
